// extracted by mini-css-extract-plugin
module.exports = {"circlegif":"Errorpage_circlegif__1aZQd","circleText":"Errorpage_circleText__3jQaQ"};